import React from "react";
import PropTypes from "prop-types";
import { modal } from "../common/modal";
import scrollToElement from 'scroll-to-element';

export const openLink = (history, props, e) => {
  const href = props.href || props.to;
  if(props.onClick) {
    props.onClick(e);
  } else if (href && props.target) {
    window.open(href, props.target);
  } else if (href.match(/https?:\/\//) || props.external) {
    location.href= href;
  } else if (href) {
    modal.closeModal();
    history.push(href);
    if (!props.cancelScroll) {
      const match = href.match(/\#(.*)$/);
      const hash = match && match[1];
      if(hash){
        setTimeout(() => {
          const targetElement =
            (hash && document.getElementById(hash)) || document.body;
            scrollToElement(targetElement, {
              offset: window.innerWidth >= 1024 ? -120 : -60
            })
        }, 100);
      }
    }
  }
};

export class Link extends React.Component {
  static contextTypes = {
    router: PropTypes.object,
  };
  openLink = e => {
    e.preventDefault();
    if (this.props.shouldLinkHandler) {
      if (this.props.shouldLinkHandler()) {
        openLink(this.context.router.history, this.props, e);
      }
    } else {
      openLink(this.context.router.history, this.props, e);
    }
  };
  render() {
    if(this.props.href || this.props.to || this.props.onClick) {
      return (
        <a {...this.props} href={this.props.to || "#"} onClick={this.openLink}>
          {this.props.children}
        </a>
      );
    } else {
      return (
        <div>
          {this.props.children}
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./lib/Link.jsx